document.addEventListener('change', event => {
    const {target} = event;

    if (!target.matches('input[type=checkbox]')) {
        return;
    }

    const conditionalInputElement = target.closest('.conditional-input');

    if (!conditionalInputElement) {
        return;
    }

    const textInput = conditionalInputElement.querySelector('input[type=text]');

    if (target.checked) {
        textInput.removeAttribute('disabled');
    } else {
        textInput.setAttribute('disabled', '');
    }
});
